export namespace Global {
    export enum ToastType {
        OK,
        Error,
        Warnning,
    }

    export const UserEvent = {
        UpdateMoney: "updateMoney",
        PlayerPyChanged: "playerPyChanged",
        PlayerLogin: "playerLogin",
        PlayerLogout: "playerLogout",
        GameListChanged: "gameListChanged",
        CloseThirdGame: "closeThirdGame",
        HallLoaded:"hallLoaded",
        LoadingHallEnd: "loadingHallEnd",
        MsgListChanged: "msgListChanged",
        EnterHall: "enterHall",
        ExitHall: "exitHall",
        AddOftenGameConfig: "addOftenGameConfig",
        CheckSignal: "CheckSignal",
        XimaGameDetail: "XimaGameDetail",
        GetWakeUpParams: "getWakeUpParams",
        AfterLogin: "afterLogin",
        OpenBaoxiang: "openBaoxiang",
        OpenThirdPayment: "openThirdPayment",
        UpdateShareTaskBtn: "updateShareTaskBtn",
        OrientationChanged: "orientationChanged",
        UpdateShareRedPoint: "UpdateShareRedPoint",
        OpenMantain: "OpenMantain",
    }
    
    /**
     * 简单滚动视图事件类型
     */
    export enum SimpleScrollViewEventType {			
        SCROLL_TO_TOP,
        SCROLL_TO_BOTTOM,
        SCROLL_TO_LEFT,
        SCROLL_TO_RIGHT,
        SCROLLING,
        SCROLL_ENDED,
        TOUCH_UP,
        SCROLL_BEGAN,		
    }

    /**
     * 简单滚动视图滑动方向
     */
    export enum SimpleScrollViewDirection {			
        HORIZONTAL,
        VERTICAL,
    }
    
    /**
     * 椭圆舞台事件类型
     */
    export enum EllipticalStageEventType {	
        ROTATING,
        ROTATE_ENDED,
        TOUCH_UP,
        ROTATE_BEGAN,			
    }

    /**
     * 游戏类型
     */
    export enum GameType {
        Default,
        Chess,              // 棋牌
        Fish,               // 捕鱼
        ESport,             // 电竞
        Electronic,         // 电子
        Live,               // 真人
        Sport,              // 体育
        Lottery,            // 彩票
    }

    /**
     * 游戏类型对应的名称
     */
    export const GameTypeName = {
        1: "棋牌游戏",
        2: "捕鱼游戏",
        3: "电竞赛事",
        4: "电子游艺",
        5: "真人视讯",
        6: "体育赛事",
        7: "彩票游戏",
    }

    /**
     * localStorageId的名称
     */
    export const localStorageId = {
        TaskCopy: "TaskCopy",
        TaskSave: "TaskSave",
        TaskShare: "TaskShare",
        TaskSubmit: "TaskSubmit",

        pauseMusic:"pauseMusic",
        MusicName:"MusicName",
        Music:"Music",
    }
    export let installParms = ["",""];

}